import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=bf67809c&scoped=true&"
import script from "./AiChat.vue?vue&type=script&lang=js&"
export * from "./AiChat.vue?vue&type=script&lang=js&"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=bf67809c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf67809c",
  null
  
)

export default component.exports